import React from "react";
import MuiDivider from "@mui/material/Divider";

type Props = {
  disableMb?: boolean;
};

const Divider = ({ disableMb = false }: Props) => {
  const stylesObj = {
    backgroundColor: "black",
    marginBottom: disableMb ? 0 : "1em",
  };
  return <MuiDivider sx={stylesObj} />;
};

export default Divider;
